import { InjectionToken } from '@angular/core';
export var MD_DATE_FORMATS = new InjectionToken('md-date-formats');
//# sourceMappingURL=date-formats.js.map


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/md2/core/datetime/date-formats.js
// module id = null
// module chunks = 